import { render, staticRenderFns } from "./MDIFeedbackCall.vue?vue&type=template&id=1c1be318&scoped=true"
import script from "./MDIFeedbackCall.vue?vue&type=script&lang=js"
export * from "./MDIFeedbackCall.vue?vue&type=script&lang=js"
import style0 from "./MDIFeedbackCall.vue?vue&type=style&index=0&id=1c1be318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1be318",
  null
  
)

export default component.exports